import type { InputHTMLAttributes, ReactNode } from 'react';
import { cx } from './cx.js';

/** Checkbox with its label attached, so the text is a hit target too. */
export function Checkbox({
  label,
  hint,
  className,
  ...rest
}: { label: ReactNode; hint?: ReactNode | undefined } & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className={cx('ui-check', className)}>
      <input {...rest} type="checkbox" />
      <span>
        {label}
        {hint ? <span className="ui-check__hint">{hint}</span> : null}
      </span>
    </label>
  );
}
